(() => {
  const getShareUrl = (root) => {
    const fallbackUrl = root.dataset.productUrl || window.location.href;
    const url = new URL(window.location.href);
    return url.origin + url.pathname || fallbackUrl;
  };

  const setOpen = (root, open) => {
    root.open = open;
  };

  const closeAll = (exceptRoot) => {
    document.querySelectorAll('[data-dorna-product-share]').forEach((root) => {
      if (root !== exceptRoot) setOpen(root, false);
    });
  };

  const buildLinks = (root) => {
    const url = getShareUrl(root);
    const title = root.dataset.productTitle || document.title;
    const text = `${title} - ${url}`;

    root.querySelectorAll('[data-dorna-share-channel]').forEach((link) => {
      const channel = link.dataset.dornaShareChannel;

      if (channel === 'whatsapp') {
        link.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
      }

      if (channel === 'facebook') {
        link.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
      }

      if (channel === 'threads') {
        link.href = `https://www.threads.net/intent/post?text=${encodeURIComponent(text)}`;
      }
    });
  };

  const copyLink = async (root, button) => {
    const url = getShareUrl(root);
    const originalText = button.textContent;
    const message = button.dataset.copyMessage || 'Link copied';

    try {
      await navigator.clipboard.writeText(url);
      button.textContent = message;
      setTimeout(() => {
        button.textContent = originalText;
      }, 1600);
    } catch (error) {
      window.prompt('Copy this link', url);
    }
  };

  document.querySelectorAll('[data-dorna-product-share]').forEach((root) => {
    buildLinks(root);
    root.addEventListener('toggle', () => {
      if (!root.open) return;
      buildLinks(root);
      closeAll(root);
    });
  });

  document.addEventListener('click', (event) => {
    const copyButton = event.target.closest('[data-dorna-share-copy]');

    if (copyButton) {
      const root = copyButton.closest('[data-dorna-product-share]');
      if (!root) return;

      copyLink(root, copyButton);
      return;
    }

    if (event.target.closest('[data-dorna-product-share]')) return;
    closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeAll();
  });
})();
